/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Stránka sa nenašla",
  "ComingSoon": "Už čoskoro",
  "YesanPersonalFinance": "Yesan, Osobné financie",
  "Yesan": "Yesan",
  "PersonalFinance": "Osobné financie",
  "YesanDownload": "Yesan na stiahnutie",
  "ThisWebsiteUsesCookies": "Súbory cookie používame na zhromažďovanie a analýzu informácií o výkone a používaní našich stránok a na poskytovanie funkcií sociálnych médií. Pokračovaním súhlasíte s našimi",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Staňte sa finančne slobodnými",
  "inStepsAndActions": "v 8 krokoch a 3 akciách.",
  "TrackPlanAnalyze": "Sledovanie: V rámci projektu \"Finančná stabilita\" môžete sledovať, či sa vám podarí získať finančnú hotovosť. Plánujte. Analyzuj.",
  "FTrack": "1. Sledovanie",
  "FPlan": "2. Plán",
  "FAnalyze": "3. Analyzovať",
  "Features": "Funkcie",
  "FeaturesSubHeading": "Čistý začiatočník, ktorý je už finančne gramotný, toto je aplikácia, ktorú potrebujete, aby ste sa stali finančne slobodnými.",
  "ManageAccounts": "Správa účtov",
  "CashLiquidFixedAssetsLiabilities": "Peňažné prostriedky, likvidné prostriedky, dlhodobý majetok a záväzky.",
  "TrackTransactions": "Sledovanie transakcií",
  "IncomesExpensesTransferInvestments": "Príjmy, výdavky, prevody, investície.",
  "ImportExport": "Import / export",
  "YourDataAlwaysAccessible": "Vaše údaje sú vždy dostupné.",
  "PlanYourFreedom": "Plánujte svoju slobodu",
  "StepsAwayFromFI": "8 krokov od finančnej nezávislosti.",
  "BudgetsAndGoals": "Rozpočty a ciele",
  "CheckYourProgressAndAchieve": "Skontrolujte svoj pokrok a dosiahnite svoje finančné ciele.",
  "DashboardAndAnalytics": "Informačný panel a analytika",
  "ReviewLearnOptimizeWith": "Kontrolujte, učte sa, optimalizujte pomocou grafov, prehľadov a nástrojov.",
  "Security": "Bezpečnosť",
  "MilitaryGradeEncryption": "Šifrovanie na vojenskej úrovni, podpora biometrie, údaje uložené vo vašich zariadeniach.",
  "OfflineMode": "Režim offline",
  "YourDataAlwaysAccessibleAndModif": "Vaše údaje vždy prístupné a upraviteľné.",
  "Track": "Sledovanie",
  "Income": "Príjmy",
  "Expense": "Výdavky",
  "Transfer": "Prenos",
  "transactionsAndManageAccounts": "transakcie a spravovať rôzne účty:",
  "checkings": "Kontrola",
  "savings": "Sporenie",
  "realEstate": "Nehnuteľnosti",
  "stocks": "Akciové trhy",
  "bonds": "Dlhopisy",
  "crypto": "Krypto",
  "notes": "Dlhopisy, peňaženka",
  "envelopes": "Obálky",
  "privateEquity": "Súkromný kapitál",
  "metal": "Kov",
  "retirement": "Dôchodok",
  "lifeInsurance": "Životné poistenie",
  "intellectualProperty": "Duševné vlastníctvo",
  "otherLiquidAsset": "Iné likvidné aktíva",
  "otherFixedAsset": "Ostatný dlhodobý majetok",
  "mortgage": "Hypotéka",
  "loan": "Spotrebiteľský úver",
  "creditCard": "Kreditná karta",
  "otherLiability": "Ostatné pasíva",
  "AccountsManagement": "Správa účtov",
  "MultipleAccountsTypesAndGrouping": "Viacero typov účtov a ich zoskupovanie",
  "LinkAccounts": "Prepojenie účtov z vašich inštitúcií (dostupné len v niektorých krajinách)",
  "SmartAccounts": "Inteligentné účty",
  "AddEditDeleteTransactions": "Pridávanie / úprava / mazanie transakcií",
  "TickVerifiedTransactions": "Označte overené transakcie",
  "CategorizeTransactions": "Kategorizácia transakcií",
  "TagTransactions": "Označovať transakcie",
  "TrackKakeiboType": "Sledovať typ Kakeibo",
  "TrackInvestments": "Sledovať investície (dostupné len v niektorých krajinách)",
  "ImportFromCSVFile": "Importovať celé alebo postupne transakcie zo súboru CSV",
  "ExportToCSVFile": "Exportovať transakcie do súboru CSV",
  "stepsTowardsFIPlanBudgetingReachGoals": "8 krokov k plánu finančnej nezávislosti, podrobné zostavenie rozpočtu, rýchlejšie dosiahnutie finančných cieľov.",
  "levelsTowardsFI": "8 stupňov k finančnej nezávislosti",
  "EstablishBudgetsPer": "Stanovenie rozpočtov na",
  "account": "účet",
  "accountType": "typ účtu",
  "KakeiboType": "Kakeibo typ účtu",
  "category": "kategória",
  "tag": "značka",
  "label": "štítok",
  "TrackBudgetsPerFrequency": "Sledovanie rozpočtov podľa frekvencie",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Vytvárajte ciele týkajúce sa výdavkov, zostatku, peňažných tokov, akcií",
  "TrackGoalsProgress": "Sledovanie pokroku pri plnení cieľov",
  "ReviewLearnOptimizeWithReportsCharts": "Prehľad, učenie sa, optimalizácia pomocou prehľadov, grafov, trendov, prehľadov, nástrojov.",
  "Dashboard": "Informačný panel",
  "FSNetWorth": "Finančné výkazy: Čistý majetok",
  "FSPnL": "Finančné výkazy: Výkaz ziskov a strát",
  "FSBalanceSheetAssetsLiabilities": "Finančné výkazy: Súvaha, aktíva, pasíva",
  "FSCashFlow": "Finančné výkazy: Výkaz peňažných tokov, debet, kredit, toky",
  "FSFlows": "Finančné výkazy: Toky",
  "FSRatios": "Finančné výkazy: Pomery:",
  "TrendsMonthEnd": "Trendy ku koncu mesiaca: Príjmy a výdavky, peňažné toky",
  "TrendsPerformance": "Trendy výkonnosti: Medziročne, Medzimesačne, WoW",
  "IncomeTrendsPer": "Trendy príjmov za",
  "SpendingTrendsPer": "Trendy výdavkov na",
  "RecurringItemsIE": "Opakujúce sa položky: Príjmy a výdavky",
  "DebtProgressTrends": "Trendy vývoja dlhu",
  "KakeiboMTDReviewTrends": "Kakeibo: Prehľad MTD, posledný mesiac, trendy",
  "FIWCLE": "Finančná nezávislosť: Nástenný graf, výdavky podľa životnej energie",
  "DebtPaydownSnowballAvalanche": "Splácanie dlhu: Dlh: Snehová guľa, lavína",
  "FullyCustomizableAnalyticsRange": "Plne prispôsobiteľný časový rozsah analytiky",
  "ContactUs": "Kontaktujte nás",
  "Privacy": "Ochrana osobných údajov",
  "Terms": "Podmienky",
  "About": "O stránke",
  "IAgreeToThe": "Súhlasím s",
  "AndThe": "a",
  "PrivacyPolicy": "Zásadami ochrany osobných údajov",
  "TermsOfUse": "Podmienky používania",

  "DigitalSoftwareExperienceTagline": "Digitálny softvér pre moderný svet",
  "DigitalExperience": "Digitálne skúsenosti",
  "SoftwareForTheModernWorld": "Softvér pre moderný svet",
  "MobileApplications": "Mobilné aplikácie",
  "forConnectedAndOfflineHumans": "pre pripojených a offline ľudí",
  "CloudSaaS": "Cloud SaaS",
  "ResponsiveAndWebServices": "Responzívne a webové služby",
  "PersonalFinanceServices": "Služby v oblasti osobných financií",
  "YS_p1": "Yesan je dynamická softvérová spoločnosť, ktorá sa špecializuje na vývoj špičkových mobilných aplikácií na mieru pre spotrebiteľov. Spoločnosť Yesan veľmi dobre rozumie vyvíjajúcim sa potrebám a preferenciám dnešných technicky zdatných používateľov a venuje sa vytváraniu intuitívnych, pútavých a funkčne bohatých mobilných zážitkov, ktoré obohacujú život používateľov.",
  "YS_p2": "Jadrom poslania spoločnosti Yesan je neúnavný záväzok k inováciám a kreativite, pričom každý produkt je starostlivo vytvorený tak, aby poskytoval bezproblémovú funkčnosť a výnimočný používateľský zážitok.",
  "PersonalFinanceApplication": "Aplikácia osobných financií",
  "YPF_p1": "Yesan, Osobné financie je špičková mobilná aplikácia pre osobné financie navrhnutá tak, aby používateľom poskytla komplexné nástroje na správu financií pohodlne dostupné na dosah ruky. Vďaka elegantnému a intuitívnemu rozhraniu ponúka aplikácia Yesan, Personal Finance komplexný prístup k správe financií, ktorý vyhovuje používateľom so všetkými úrovňami finančnej gramotnosti.",
  "YPF_p2": "Medzi kľúčové funkcie patrí sledovanie rozpočtu, kategorizácia výdavkov a monitorovanie transakcií v reálnom čase, čo používateľom umožňuje bez námahy získať prehľad o svojich výdavkových návykoch. Aplikácia tiež ponúka prispôsobiteľné možnosti zostavovania rozpočtu, čo používateľom umožňuje nastaviť si finančné ciele a sledovať ich pokrok v priebehu času.",
  "YPF_p3": "Yesan, Personal Finance navyše uprednostňuje bezpečnosť a využíva najmodernejšie šifrovacie protokoly na ochranu citlivých finančných informácií používateľov. Vďaka bezpečnostným opatreniam na úrovni banky môžu používatelia bez obáv prepojiť svoje účty a synchronizovať transakcie bez toho, aby bolo ohrozené ich súkromie.",
  "YPF_p4": "Yesan, Personal Finance presahuje rámec základného rozpočtovania tým, že ponúka prehľadnú analýzu a personalizované odporúčania na optimalizáciu finančných rozhodnutí. Či už ide o identifikáciu potenciálnych možností úspor, monitorovanie investičných portfólií alebo riadenie stratégií splácania dlhov, aplikácia poskytuje poznatky šité na mieru, ktoré používateľom pomôžu dosiahnuť ich finančné ciele.",
  "Discover": "Objavte",
  "Firstname": "Krstné meno",
  "Lastname": "Priezvisko",
  "Company":"Spoločnosť",
  "Subject": "Predmet",
  "Email": "E-mail",
  "Message": "Správa",
  "ThankYouForContactingUs": "Ďakujeme, že ste nás kontaktovali",
  "ValidFirstnameRequired": "Vyžaduje sa platné meno.",
  "ValidLastnameRequired": "Vyžaduje sa platné priezvisko.",
  "ValidEmailAddressRequired": "Zadajte platnú e-mailovú adresu.",
  "ValidSubjectRequired": "Prosím, vyberte platný predmet.",
  "ValidMessageRequired": "Zadajte prosím platnú správu.",
  "UnableToSendTheFormPleaseRetryLater": "Formulár sa nepodarilo odoslať, skúste to prosím neskôr.",
  "Information": "Informácie",
  "Sales":"Predaj",
  "Support": "Podpora",
  "Press": "Tlač",
  "Partnership": "Partnerstvo",
  "Other": "Iné",
  "Blog":"Blog",

  "Accept":"Prijať",
  "Decline":"Odmietnuť",

  "WorklogCalendar":"Pracovný kalendár pre Jira",

  "DirectlyAccessibleInProjectApps":"Priamo prístupné v aplikáciách projektu",
  "VisualizeWhereYouSpentYourTime":"Vizualizujte, kde ste strávili svoj čas",
  "AllYourWorklogsInACalendar":"Všetky vaše pracovné záznamy v kalendári",
  "MonthSummary":"Mesačný prehľad",
  "CheckIfYouForgotToLogTime":"Skontrolujte, či ste nezabudli zaznamenať čas.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Priamy prístup k problémom a aktualizácia času",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Kliknutím na položku pracovného denníka získate priamy prístup k problémom a môžete upravovať sledovaný čas",
  "AlsoAvailableInDarkMode":"K dispozícii aj v tmavom režime",
  "DirectlyLogWorkOnTheCalendarVisually":"Priamo zaznamenávať prácu do kalendára vizuálne",
  "ClickOnTheCalendarToCreateNewWorklog":"Kliknutím na kalendár vytvoríte nový pracovný denník",

  "AppsForAtlassian":"Aplikácie pre Atlassian",
  "YCL_p1":"Vizualizujte všetky svoje pracovné záznamy v kalendári so zobrazením na mesiac, týždeň, pracovný týždeň a deň.",
  "YCL_p2":"Zaznamenávajte prácu priamo z kalendára vizuálnym výberom časového úseku.",
  "YCL_p3":"Identifikujte, či ste zabudli sledovať čas pre svoje časové hárky.",
  "YCL_p4":"K dispozícii vo vašom jazyku: (UK), angličtina (USA), čínština (zjednodušená), čínština (tradičná), čeština, dánčina, estónčina, fínčina, francúzština, islandčina, holandčina, japončina, kórejčina, nemčina, nórčina, poľština, portugalčina (Brazília), portugalčina (Portugalsko), ruština, španielčina, švédčina, turečtina, taliančina.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Finančné portfólio pre Jira",
  "BringRealFinancialPortfolio":"Zavádzame do Jiry skutočné riadenie finančného portfólia. Sledujte rozpočty, investičné a prevádzkové náklady a náklady na projekty na jednom mieste.",
  "YFPAboutQ":"Koľko nás naše projekty v Jire skutočne stoja?",
  "YFPAbout":"Finančné portfólio pre Jira\nFinanční riaditelia a PMO sa snažia odpovedať na jednoduchú otázku:\nKoľko nás naše projekty v Jira skutočne stoja?\nJira sleduje prácu.\nFinančné oddelenie sleduje rozpočty.\nTáto aplikácia konečne spája tieto dve veci.\n\nFinančné portfólio premení Jira na ľahkú platformu PPM + finančného plánovania — bez potreby drahých podnikových nástrojov.",
  "YFPPorfolioQ":"Rozpočty a sledovanie portfólia",
  "YFPPorfolioP":"Vytvorte portfóliá naprieč viacerými projektmi Jira a definujte: Výšku rozpočtu, Mena, Časové obdobie, Zahrnuté projekty, tímy. Automaticky sledujte skutočné náklady v reálnom čase, ako práca prebieha v Jira.",
  "YFPPorfolioListQ":"Portfóliá",
  "YFPPorfolioListP":"Vytvorte finančné portfóliá, ktoré kombinujú viacero projektov Jira, a okamžite uvidíte: porovnanie rozpočtu a skutočných nákladov, mieru čerpania projektu v reálnom čase, rozpis CapEx a OpEx, náklady na úlohu a projekt, exportovateľné finančné správy. Všetko priamo na základe pracovných záznamov Jira.",
  "CostQ":"Automatický výpočet nákladov",
  "CostP":"Premeňte sledovanie času na skutočné finančné údaje. Aplikácia: číta pracovné záznamy v Jira, uplatňuje hodinové sadzby, denne vypočítava skutočné náklady projektu. Žiadne tabuľky. Žiadna manuálna práca.",
  "RatesQ":"Sadzby",
  "RatesP":"Nastavte hodinovú sadzbu na projekt, tím alebo globálne",
  "ReportQ":"Finančné výkazníctvo vo formáte CSV",
  "ReportP":"Exportujte finančné údaje portfólia za pár sekúnd. Ideálne pre: Finančné tímy, výkazníctvo pre finančného riaditeľa, plánovanie rozpočtu, podporu auditu",
  "SettingsQ": "Klasifikácia CapEx vs. OpEx",
  "SettingsP": "Podpora účtovných a audítorských požiadaviek. Klasifikujte prácu na: Kapitalizovateľný vývoj (CapEx), prevádzková činnosť (OpEx). Generujte exportovateľné správy pripravené pre finančné tímy."
};

export const documents = {
};
